<template>
    <div class="rule-dialog">
      <b-modal 
        id="modalSurvey" 
        modal-class="custom-dialog dialog-1100"
        ok-only 
        no-close-on-esc 
        no-close-on-backdrop
        no-footer
        hide-footer
        scrollable
        @close="close">
        <template #modal-header="{ close }">
            <feather-icon
                icon="XIcon"
                size="22"
                class="icon-hover"
                @click="close()"
            />
        </template>
        <div class="bg-white">
            <div class="survey-container">
            <div v-if="!loading.survey">
                <h1 class="mb-3 mt-50"><strong>{{displayedSurvey.name}}</strong></h1>
                <p class="ml-1 mb-3 survey-description">{{ displayedSurvey.description }}</p>
                <div class="ml-1 mb-1">
                    <form-render :form.sync="form" :fields="fields" @send="sendSurvey" ref="formRenderSurvey" :key="keyFormRender">
                    </form-render>
                </div>
            </div>
            <div v-else class="center-spinner mb-3 mt-3">
                <b-spinner />
            </div>
            <div class="d-flex justify-content-center survey-btn">
                <b-button @click="validateForm" :disabled="loading.save" variant="warning">
                    <span>Enviar</span>
                </b-button>
            </div>
            </div>
        </div>
      </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
export default {
  data () {
    return {
      surveys: [],
      displayedSurvey: {},
      fields: [],
      form: {},
      keyFormRender: 0,
      loading: {
        survey: true,
        save: false
      },
      baseService: new BaseServices(this),
      direct_billing: true,
      CONDITIONS: Object.freeze({
        OPEN_SURVEY_POPUP: 'OPEN_SURVEY_POPUP'
      })
    }
  },
  watch: {
    mySession () {
      if (this.mySession.id) this.setInitialData()
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession'
    })
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    setInitialData () {
      this.isAdmin = this.mySession.role === 'admin'
      if (!this.isAdmin) this.getPopUp()
    },
    async getPopUp () {
      this.shipper_id = this.mySession.shipper?.id
      if (['seller'].includes(this.mySession.role)) await this.getCompanyInfoBilling()
      const params = {}
      const queryParams = {
        direct_billing: this.direct_billing
      }
      this.baseService.callService('getSurveyPopUp', queryParams, params)
        .then(resp => {
          const value = resp.data
          if (!!value) {
            this.loading.survey = false
            this.survey_pop_up = value
            const survey = this.formatterSurvey(value)
            this.displayedSurvey = survey
            this.setFields()
            this.$emit('handleTypeModal', true, this.CONDITIONS.OPEN_SURVEY_POPUP)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getCompanyInfoBilling () {
      return this.baseService.callService('getCompanyInfoBillingNotifications', null, { company_id: this.shipper_id })
        .then(resp => {
          this.hasBillignData(resp.data)
        })
        .catch(err => {
          console.error(err)
        })
    },
    hasBillignData(data) {
      if (!!data.hasBusinessData) {
        this.getBillingDataCompany()
      } else {
        this.direct_billing = false
      }
    },
    getBillingDataCompany () {
      return this.baseService.callService('getManageBillingDataCompany', null, { company_id: this.shipper_id })
        .then(resp => {
          this.direct_billing = resp.data.directBilling
        })
        .catch(err => {
          this.direct_billing = false
          console.error(err)
        })
    },
    formatterSurvey (value) {
      if (value && value.questions) {
        value.questions.forEach(question => {
          if (question.options) {
            question.options.forEach(option => {
              option.text = option.value
              delete option.value
            })
          }
        })
      }
      return value
    },
    setFields () {
      if (this.displayedSurvey.questions) {
        this.displayedSurvey.questions.map((question, index) => {
          const idType = question.type.id
          let field = {}
          if ([3].includes(idType)) {
            const range = question.range
            field = {
              fieldType: 'FieldRadio',
              name: `${question.id}`,
              type: 'type',
              label: `${index + 1}. ${question.title}`,
              align: 'h',
              scaleIndicators: true,
              scaleText: {start: range?.text_start, end: range?.text_end},
              options: Array.from(
                { length: range.end - range.start + 1 },
                (_, i) => ({
                  id: parseInt(range.start) + i,
                  text: (parseInt(range.start) + i).toString()
                })
              ),
              containerClass: 'col-12 container-info scale-custom',
              validation: question.is_required ? 'required' : '',
              descriptionTag: question.description ? {text: question.description, style: 'survey-description-custom'} : null
            }
          } else if ([1, 2].includes(idType)) {
            field = {
              fieldType: idType === 1 ? 'FieldCheckbox' : 'FieldRadio',
              name: `${question.id}`,
              type: 'type',
              label: `${index + 1}. ${question.title}`,
              containerClass: 'col-12 container-info custom-fields-survey',
              options: question.options,
              multiple: true,
              validation: question.is_required ? 'required' : '',
              descriptionTag: question.description ? {text: question.description, style: 'survey-description-custom'} : null
            }
          } else if (idType === 4) {
            field = {
              fieldType: 'FieldTextarea',
              name: `${question.id}`,
              label: `${index + 1}. ${question.title}`,
              containerClass: 'col-sm-12 container-info mb-2',
              validation: question.is_required ? 'required' : '',
              placeholder: 'Ingresa tu respuesta aquí.',
              rows: 3,
              descriptionTag: question.description ? {text: question.description, style: 'survey-description-custom'} : null
            }
          }
          this.fields.push(field)
        })
      }
    },
    hideSurvey () {
      this.loading.save = false
      this.$emit('handleTypeModal', false, this.CONDITIONS.OPEN_SURVEY_POPUP)
    },
    close () {
      const queryParams = {
        survey_id: this.survey_pop_up.id
      }
      const params = {}
      this.$store.dispatch('fetchService', { 
        name: 'closeSurveyPopUp', 
        queryParams, 
        params, 
        onSuccess: () => this.hideSurvey()
      })
    },
    validateForm () {
      this.$refs.formRenderSurvey.checkForm()
    },
    formatterPayload (myForm, infoSurvey) {
      return Object.keys(myForm).map(questionId => {
        const question = infoSurvey.find(q => q.id === Number(questionId))
        if (!question) return null
        const { id: item_id, type: { id: type_id } } = question
        const answer = myForm[questionId]
        const formattedAnswer = [1, 2, 4].includes(type_id) ? answer : type_id === 3 ? answer.text : null
        return { item_id, type_id, answer: formattedAnswer }
      }).filter(Boolean)
    },
    sendSurvey (myForm) {
      this.loading.save = true
      const queryParams = {
        survey_id: this.survey_pop_up.id,
        items: this.formatterPayload(myForm, this.survey_pop_up.questions)
      }
      const params = {}
      this.$store.dispatch('fetchService', { 
        name: 'responseSurveyPopUp', 
        queryParams, 
        params, 
        onSuccess: () => this.hideSurvey()
      })
    }
  }
}
</script>
<style>
.survey-container {
  padding: 1.5rem
}
.survey-container h1 {
  color: #000;
}
.survey-description{
  white-space: pre-line;
}
#modalSurvey .modal-header {
  display: flex;
  justify-content: end;
  align-items: center;
  background: linear-gradient(90deg, #395494 0%, #31AEE4 100%);
  height: 60px;
  color: #ffffffd2;
}
.survey-btn button{
  padding: 0.786rem 3.5rem;
}
.icon-hover {
  cursor: pointer;
} 
.survey-container .label-form {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 1rem;
} 
.scale-custom .bv-no-focus-ring {
  /* margin-top: 1.5rem; */
  margin-top: 1rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.scale-custom .custom-control {
  flex-direction: column-reverse;
  align-items: center;
  position: relative;
}
.scale-custom .custom-control-input {
  position: absolute;
  margin-bottom: 0px;
  bottom: -2px;
  left: 25px;
  right: -26px;
}
.scale-custom .custom-control-label{
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}
.scale-custom .custom-control-label::before{
  position: relative;
}
.scale-custom .custom-control-label::after {
  display: none;
}
.custom-fields-survey .custom-control {
  margin: 1rem 0;
}
#modalSurvey .modal-dialog-scrollable .modal-body::-webkit-scrollbar {
  -webkit-appearance: none;
}
#modalSurvey .modal-dialog-scrollable .modal-body::-webkit-scrollbar:vertical {
  width: 11px;
}
#modalSurvey .modal-dialog-scrollable .modal-body::-webkit-scrollbar:horizontal {
  height: 11px;
}
#modalSurvey .modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, .5);
}
#modalSurvey .modal-dialog-scrollable .modal-body::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
.center-spinner {
  display: flex;
  justify-content: center;
}
.survey-description-custom {
  margin-top: 0;
}
@media (max-width: 768px) {
  .scale-custom .bv-no-focus-ring {
    flex-direction: column;
  }
}
</style>